const TRACKING_QUERY_PARAMS = new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "msclkid",
  "_ga",
  "_gl",
]);

export type BuildCanonicalUrlOptions = {
  /** When true (default), strip known marketing / analytics query params. */
  dropTrackingParams?: boolean;
};

/**
 * Builds a stable canonical URL for the current document URL.
 * Trailing slash on non-root paths is removed; meaningful query strings are kept.
 */
export function buildCanonicalUrl(
  href: string,
  options: BuildCanonicalUrlOptions = {}
): string {
  const { dropTrackingParams = true } = options;
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return href;
  }

  if (dropTrackingParams) {
    Array.from(url.searchParams.keys()).forEach(key => {
      if (TRACKING_QUERY_PARAMS.has(key)) {
        url.searchParams.delete(key);
      }
    });
  }

  const normalizedPath =
    url.pathname !== "/" && url.pathname.endsWith("/")
      ? url.pathname.slice(0, -1)
      : url.pathname;
  const normalizedSearch = url.searchParams.toString();

  return `${url.origin}${normalizedPath}${normalizedSearch ? `?${normalizedSearch}` : ""}`;
}
